(function () {
    function waitForElement(selector, callback) {
        var elementCheck = setInterval(function () {
            var element = document.querySelector(selector);
            if (element) {
                clearInterval(elementCheck);
                callback(element);
            }
        }, 50); 
    }

    function initializeSwiper(container) {
        var swiperInstance = new Swiper(container, {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 40,
                },
            },
            pagination: {
                el: ".wls-swiper-ugc__pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".slider-ugc-next",
                prevEl: ".slider-ugc-prev",
            },
        });

        swiperInstance.on('slideChangeTransitionEnd', function () {
            refreshVideoLogic();
        });

        return swiperInstance;
    }

    function initializeVideoLogic() {
        var videos = document.querySelectorAll(".wls-ugc__item-video video");

        if (videos.length > 0) {
            videos.forEach(function (video) {
                var parentItem = video.closest(".wls-ugc__item");

                parentItem.addEventListener("mousedown", function (event) {
                    event.stopPropagation(); 
                });

                video.addEventListener("click", function () {
                    stopPlayingCurrentVideo(video.id);
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                    if (parentItem) {
                        parentItem.classList.toggle("playing", !video.paused);
                    }
                });
            });
        }
    }

    function refreshVideoLogic() {
        var videos = document.querySelectorAll(".wls-ugc__item-video video");

        videos.forEach(function (video) {
            var parentItem = video.closest(".wls-ugc__item");
            if (parentItem && parentItem.classList.contains("playing")) {
                video.pause();
                parentItem.classList.remove("playing");
            }
        });
    }

    function stopPlayingCurrentVideo(videoId) {
        var currentPlayingParent = document.querySelector(".wls-ugc__item.playing");
        if (currentPlayingParent) {
            currentPlayingParent.classList.remove("playing");
            var currentPlayingVideo = currentPlayingParent.querySelector("video");
            if (currentPlayingVideo?.id !== videoId) {
                currentPlayingVideo.pause();
            }
        }
    }

    waitForElement(".wls-ugc__items", function (wlsSliderUgc) {
        initializeSwiper(wlsSliderUgc);

        initializeVideoLogic();
    });
})();
